import styled from 'styled-components';

export const CountStyled = styled.span`
  width: 22px;
  padding: 0 0.5rem;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.6px;
  opacity: 0.7;
`;
